<template>
  <div class="lego-pagination" v-if="pagination.totalItems > 0">
    <div
      v-if="!simple"
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isLeftPart },
        { 'lego-pagination__icon--hide': range.length <= 10 && !isPadPart }
      ]"
      @click.stop="onClickLeftPart"
    >
      <lego-icon
        class="lego-pagination__left-icon"
        icon-type="df"
        icon="pagination_left_end_24"
        :size="24"
      />
    </div>
    <div
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isLeftEnd },
        { 'lego-pagination__icon--hide': range.length <= 1 }
      ]"
      @click.stop="onClickLeft"
    >
      <lego-icon
        class="lego-pagination__left-icon"
        icon-type="df"
        icon="pagination_left_24"
        :size="24"
      />
    </div>
    <template v-if="!simple">
      <template v-if="isShowFirstZone">
        <div
          class="lego-pagination__number"
          :class="{ 'lego-pagination__selected': selectedPage(1) }"
          @click="clickToMovePage(1)"
        >
          1
        </div>
        <!--
                -->
        <div class="lego-pagination__number-dots">...</div>
      </template>
      <div
        v-for="(n, idx) in range"
        :key="idx"
        @click="clickToMovePage(n)"
        class="lego-pagination__number lego-pagination__range-area"
        :class="{
          'lego-pagination__selected': selectedPage(n),
          'lego-pagination__number--disable': range.length <= 1 ? true : false
        }"
      >
        {{ n }}
      </div>
      <template v-if="isShowLastZone">
        <div class="lego-pagination__number-dots">...</div>
        <!--
                -->
        <div
          class="lego-pagination__number"
          :class="{ 'lego-pagination__selected': selectedPage(pages) }"
          @click="clickToMovePage(pages)"
        >
          {{ pages }}
        </div>
      </template>
      <div v-if="this.pages === 0" class="lego-pagination__number lego-pagination__icon--disable">
        1
      </div>
    </template>
    <template v-else>
      <!-- <lego-counter
        class="lego-pagination__simple-pager"
        :style="gotoCounterStyle"
        :disabled="isNoItem"
        :min="isNoItem ? 0 : 1"
        :max="pages"
        :value="isNoItem ? 0 : goToPage"
        @input="goToInputValidation"
        @enter="moveToPage"
      /> -->
      {{ isNoItem ? 0 : goToPage }}
      /
      {{ pagination.totalPages }}
    </template>
    <div
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isRightEnd },
        { 'lego-pagination__icon--hide': range.length <= 1 }
      ]"
      @click.stop="onClickRight"
    >
      <lego-icon
        class="lego-pagination__right-icon"
        icon-type="df"
        icon="pagination_right_24"
        :size="24"
      />
    </div>
    <div
      v-if="!simple"
      class="lego-pagination__navi"
      :class="[
        { 'lego-pagination__icon--disable': isRightPart },
        { 'lego-pagination__icon--hide': range.length <= 10 && !isPadPart }
      ]"
      @click.stop="onClickRightPart"
    >
      <lego-icon
        class="lego-pagination__right-icon"
        icon-type="df"
        icon="pagination_right_end_24"
        :size="24"
      />
    </div>
    <div class="lego-pagination__goto" v-if="showGotoButton && !simple && pages > 11">
      <lego-counter
        :value="isNoItem ? 0 : goToPage"
        :style="gotoCounterStyle"
        @input="goToInputValidation"
        @enter="moveToPage"
        no-control
        :min="isNoItem ? 0 : 1"
        :max="pages"
        :disabled="isNoItem"
      ></lego-counter>
      <lego-button md @click="moveToPage" :disabled="isNoItem">{{ $_moveMessage }}</lego-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagePart: 10
    };
  },
  emits: ['move'],
  props: {
    showGotoButton: { type: Boolean, default: false },
    props: {
    // $ver: v0.1.0
    // 페이징 처리를 위한 속성 객체입니다. rowsPerPage, currentPage, totalPages, totalItem 속성을 가지고 있습니다.
    // #Property object for paging processing. It has rowsPerPage, currentPage, totalPages and totalItem properties.
    // $default: rowsPerPage - 10, currentPage - 1, totalPages - 0, totalItem - 0
    pagination: {
      type: Object,
      required: true,
      default: () => {
        return {
          rowsPerPage: 10,
          currentPage: 1,
          totalPages: 0,
          totalItems: 0,
        };
      },
    },
    // $ver: v0.1.0
    // Simple 유형 여부입니다.
    // #Whether it is a Simple type.
    // $default: false
    simple: { type: Boolean, default: false },

    // $ver: v0.1.2
    // 페이지 입력 및 바로 이동을 위한 버튼 텍스트 입니다.
    // #Button text for page input and direct navigation.
    // $default: 'GO'
    moveMessage: { type: String },
  },
  },
  computed: {
    isPadPart() {
      return this.pagination.totalItems / this.pagination.rowsPerPage > 10;
    },
    isLeftPart() {
      return this.page <= this.pagePart;
    },
    isRightPart() {
      return this.page + this.pagePart > this.pages;
    }
  },
  methods: {
    onClickLeftPart() {
      this.page = this.page - this.pagePart;
      this.goToPage = this.page;
      this.$emit('move', this.page);
    },
    onClickRightPart() {
      this.page = Number(this.page) + this.pagePart;
      this.goToPage = this.page;
      this.$emit('move', this.page);
    }
  }
};
</script>
<style scoped lang="scss">
.lego-pagination {
  @include font($size: $lego-pagination__font-size);

  .lego-pagination__number {
    width: inherit;
    padding: 0 8px;
  }

  :deep .lego-pagination__left-icon,
  :deep .lego-pagination__right-icon {
    transform: rotate(0deg);
  }

  .lego-pagination__icon {
    &--disable {
      :deep .lego-icon {
        color: $lego-pagination__navi__icon-color--disabled;
      }
    }
    &--hide {
      display: none;
    }
  }

  .lego-pagination__navi {
    &:hover {
      background: none;
      :deep .lego-icon {
        color: $color--ui01;
      }
    }
  }
  .lego-pagination__number {
    &:active {
      color: $color--primary;
      font-weight: $lego__font-weight--bold;
    }
  }
}
</style>
